import { useEffect } from 'react';
import { useFetch } from '@ohpen/react-utils';
import { notification } from '@ohpen/enso-ui';
import * as pmpSdk from '@pmp/api';
import { getApiErrorMessage } from '@pmp/utils';

type FunctionOnly<T> = {
  [K in keyof T as T[K] extends (...args: any[]) => Promise<any> ? K : never]: T[K];
};

const DEDUPE_WINDOW_MS = 2000;
const lastShownAt = new Map<string, number>();

const showOnce = (title: string) => {
  const now = performance.now();
  const previous = lastShownAt.get(title);
  if (previous !== undefined && now - previous < DEDUPE_WINDOW_MS) return;
  lastShownAt.set(title, now);
  notification().error({ title });
};

function usePmpFetch<P extends keyof FunctionOnly<typeof pmpSdk>>(methodName: P, options?: { notifyOnError?: boolean }) {
  const result = useFetch(pmpSdk as FunctionOnly<typeof pmpSdk>, methodName);
  const error = result[1];
  const notifyOnError = options?.notifyOnError ?? true;

  useEffect(() => {
    if (error && notifyOnError) showOnce(getApiErrorMessage(error));
  }, [error, notifyOnError]);

  return result;
}

export { usePmpFetch };
